<template>
  <base-card>
    <div class="tw-flex tw-flex-col">
      <h3 class="tw-text-gray-700 tw-text-lg tw-font-thin tw-whitespace-nowrap tw-mb-5">Prescription Programs <span class="tw-text-sm">(by group)</span></h3>
      <div class="chart-container tw-self-center">
        <div v-if="isLoading" class="tw-bg-gray-200 tw-animate-pulse tw-rounded-full tw-h-80 tw-w-80" />
        <doughnut-chart v-else :chart-data="prescriptionGroupChartData" :options="chartOptions" style="height: 20rem" />
      </div>
    </div>
  </base-card>
</template>

<script>
import DoughnutChart from "@/components/charts/DoughnutChart";
import { mapGetters } from "vuex";

export default {
  name: "PrescriptionCountsByGroup",
  components: { DoughnutChart },
  props: {
    businessId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      prescriptionCounts: [],
      isLoading: false,
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapGetters("organization", ["organization", "cobrandId"]),
    isMobile() {
      return this.windowWidth <= 768;
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 70,
        legend: {
          display: this.isMobile === true ? false : true,
          position: "bottom",
        },
        tooltips: {
          callbacks: {
            label(tooltipItem, data) {
              let label = data.labels[tooltipItem.index] || "";

              if (label) {
                label += ": ";
              }
              label += `${data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]}`;
              return label;
            },
          },
        },
      };
    },

    prescriptionGroupChartData() {
      if (this.prescriptionCounts.length == 0)
        return {
          labels: ["No prescriptions"],
          datasets: [
            {
              label: "Program Group",
              data: [1],
              borderColor: "#cccccc", // secondary
              borderWidth: 0.5,
              backgroundColor: ["#ffffff"],
            },
          ],
        };
      else
        return {
          labels: this.prescriptionCounts.map((programGroup) => programGroup.programGroup),
          datasets: [
            {
              label: "Program Group",
              data: this.prescriptionCounts.map((programGroup) => programGroup.countPrescriptions),
              borderColor: this.programGroupBorderColor, // secondary
              borderWidth: 0.5,
              backgroundColor: this.programGroupBackgroundColors,
            },
          ],
        };
    },
    programGroupBorderColor() {
      switch (this.cobrandId) {
        case "rx-harmony":
          return "#49a13e";
      }
      return "#522e91";
    },
    programGroupBackgroundColors() {
      switch (this.cobrandId) {
        case "rx-harmony":
          return [
            "rgba(85, 185, 72, 0.8)",
            "rgba(85, 185, 72, 0.6)",
            "rgba(85, 185, 72, 0.3)",
            "rgba(85, 185, 72, 0.0)",
            "#cccccc",
            "rgba(85, 185, 72, 0.8)",
            "rgba(85, 185, 72, 0.6)",
            "rgba(85, 185, 72, 0.3)",
            "rgba(85, 185, 72, 0.0)",
            "#cccccc",
          ];
      }
      return ["#b9abd3", "#ff99d2", "#522e91", "#ff59d7", "#cccccc", "#b9abd3", "#ff99d2", "#522e91", "#ff59d7", "#cccccc"];
    },
  },
  created() {
    this.loadPrescriptionCounts();
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    loadPrescriptionCounts() {
      this.isLoading = true;

      let url = `/businesses/${this.businessId}/dashboard/prescriptions-by-group`;

      this.$axios
        .get(url)
        .then((res) => {
          this.prescriptionCounts = res.data.results;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>
